import * as types from './mutation-types'
import SurveyApi from '@/api/questionnaire'

const getSurveys = async ({commit}, params) => {
  const res = await SurveyApi.get(params)
  const surveys = res.data.data
  commit(types.SET_SURVEYS, surveys)
}
const deleteSurvey = async ({commit}, survey) => {
  commit(types.DELETE_SURVEY, survey)
}
const setIsShowSurveysModal = async ({commit}, status) => {
  commit(types.SET_IS_SHOW_SURVEYS_MODAL, status)
}

const setIsShowSurveyToLocalStorage = async ({commit}) => {
  commit(types.SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE)
}

export default {
  getSurveys,
  deleteSurvey,
  setIsShowSurveysModal,
  setIsShowSurveyToLocalStorage
}



// WEBPACK FOOTER //
// ./src/store/modules/surveys/actions.js